"use client";

import type { PropsWithChildren } from "react";
import { type CMDKPage, useCommand } from "~/app/[lang]/command/Context";

interface Props extends PropsWithChildren {
	page: CMDKPage;
}

export function CommandWrapper({ page, children }: Props) {
	const { activePage } = useCommand();

	if (page !== activePage) {
		return null;
	}

	return <>{children}</>;
}
